// Serialization
import { deserialize } from 'serializr';
import { apnSchema } from './schemas';

/**
* Serialization
*/
const deserializeApn = (data) => deserialize(apnSchema, data);

/**
* Model
*/
const apn = {
  // Name
  name: 'apn',

  // Serialization
  deserialize: deserializeApn,

  // Columns
  columns: [
    {
      key: 'name',
      labelId: 'field.name',
      field: 'name',
      sortable: false,
    },
    {
      key: 'identifier',
      labelId: 'field.apnIdentifier',
      field: 'identifier',
      sortable: false,
    },
    {
      key: 'login',
      labelId: 'field.login',
      field: 'login',
      sortable: false,
    },
    {
      key: 'password',
      labelId: 'field.password',
      field: 'password',
      sortable: false,
    },
  ],
};

module.exports = apn;



// WEBPACK FOOTER //
// ./models/apn.js